import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PlayerClassesComponent } from './containers/player-classes/player-classes.component';
import { PlayerSkillsComponent } from './containers/player-skills/player-skills.component';
import { PlayerClassEditorComponent } from './components/player-class-editor/player-class-editor.component';
import { FormsModule } from '@angular/forms';
import { AttributeStoreComponent } from './components/attribute-store/attribute-store.component';
import { TrapsComponent } from './containers/traps/traps.component';
import { MonstersComponent } from './containers/monsters/monsters.component';
import { PlayThroughComponent } from './containers/play-through/play-through.component';
import { PlayerSetupComponent } from './components/player-setup/player-setup.component';
import { StatisticsComponent } from './containers/statistics/statistics.component';
import { InventoryItemsComponent } from './containers/inventory-items/inventory-items.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { CollapseModule } from 'ngx-bootstrap/collapse'
import { PlayerClassSelectorComponent } from './components/player-class-selector/player-class-selector.component';
import { InventoryManagementComponent } from './containers/inventory-management/inventory-management.component';
import { RecruiterComponent } from './containers/recruiter/recruiter.component';
import { BlacksmithComponent } from './containers/blacksmith/blacksmith.component';
import { PlayerBlockComponent } from './components/player-block/player-block.component';

@NgModule({
  declarations: [
    AppComponent,
    PlayerClassesComponent,
    PlayerSkillsComponent,
    PlayerClassEditorComponent,
    AttributeStoreComponent,
    TrapsComponent,
    MonstersComponent,
    PlayThroughComponent,
    PlayerSetupComponent,
    StatisticsComponent,
    InventoryItemsComponent,
    PlayerClassSelectorComponent,
    InventoryManagementComponent,
    RecruiterComponent,
    BlacksmithComponent,
    PlayerBlockComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
